var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import * as Enumerable from "linq";
import { BindingSignaler } from "aurelia-templating-resources";
import { computedFrom } from "aurelia-binding";
var BundleBasicMeta = /** @class */ (function (_super) {
    __extends(BundleBasicMeta, _super);
    function BundleBasicMeta(notificationService, i18N, bindingSignaller, tokenClient, dialogClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.bindingSignaller = bindingSignaller;
        _this.tokenClient = tokenClient;
        _this.dialogClientService = dialogClientService;
        _this.displayMemberPath = function (item) { return item.lottery.name; };
        return _this;
    }
    Object.defineProperty(BundleBasicMeta.prototype, "showManageTemplate", {
        get: function () {
            return this.item.navigationInfo && this.item.navigationInfo.brandId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BundleBasicMeta.prototype, "lotteriesToHide", {
        get: function () {
            if (this.item && this.item.bundleBrandLotteries && this.item.navigationInfo && this.item.navigationInfo.brandLotteries) {
                var lotteryIds = this.item.bundleBrandLotteries.map(function (x) { return x.brandLotteryId; });
                return Enumerable.from(this.item.navigationInfo.brandLotteries).where(function (x) { return lotteryIds.indexOf(x.brandLotteryId) != -1; }).toArray();
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    BundleBasicMeta.prototype.editBranding = function () {
        require("../dialogs/bundle-branding-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.BundleBranding, this.item, false, false, true);
    };
    BundleBasicMeta.prototype.addBundleBrandLottery = function () {
        this.item.bundleBrandLotteries.push({
            brandLotteryId: null,
            sharePercentage: 20,
            numberOfDraws: 0,
            numberOfLines: 0
        });
    };
    BundleBasicMeta.prototype.removeBundleBrandLottery = function (index) {
        this.item.bundleBrandLotteries.splice(index, 1);
    };
    __decorate([
        computedFrom("item.bundleBrandLotteries", "item.navigationInfo"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BundleBasicMeta.prototype, "lotteriesToHide", null);
    BundleBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, BindingSignaler,
            TokenClient, DialogClientService])
    ], BundleBasicMeta);
    return BundleBasicMeta;
}(ChildComponent));
export { BundleBasicMeta };
